import React, { useEffect, useRef, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";

const Drawer = ({
  isOpen,
  onClose,
  DrawerContent = "",
  DrawerTitle = "",
  width = `w-[60%]`,
  keepRef = true,
}) => {
  const drawerRef = useRef(null);
  const noRef = useRef(null);
  const drawerTitleRef = useRef(null);
  const [drawerTitleHeight, setDrawerTitleHeight] = useState(0);

  useEffect(() => {
    if (drawerTitleRef.current) {
      setDrawerTitleHeight(drawerTitleRef.current.offsetHeight);
    }
  }, [isOpen]);

  return (
    <div
      className={`fixed top-0 z-50 right-0 h-full bg-white shadow-xl transform transition-transform ${
        isOpen ? "translate-x-0" : "translate-x-full"
      } ${width}`}
      ref={keepRef ? drawerRef : noRef}
    >
      <div className="flex flex-col h-full max-h-screen overflow-auto">
        <div
          className="p-4 border-b w-full bg-white fixed z-[1] flex justify-between items-center"
          ref={drawerTitleRef}
        >
          <h1 className="heading">{DrawerTitle}</h1>
          <AiOutlineClose
            className="text-xl cursor-pointer"
            onClick={onClose}
          />
        </div>
        <div className="flex-1" style={{ marginTop: drawerTitleHeight }}>
          {isOpen && DrawerContent}
        </div>
      </div>
    </div>
  );
};

export default Drawer;
